module.exports = "<svg height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 407.44 407.44\"><path d=\"M112.8 0L91.58 21.18 273.5 203.72 91.58 386.26l21.24 21.18 203.07-203.72\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/chevron-right.svg
// module id = ./src/icons/chevron-right.svg
// module chunks = 21